const formate = {}
formate.formatenumber = function (data) {
  return data < 10 ? ('0' + data) : data
}
formate.fromateTs = function (data) {
  var date = new Date(data)
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  var d = date.getDate()
  var h = date.getHours()
  var mm = date.getMinutes()
  var s = date.getSeconds()
  return y + '-' + this.formatenumber(m) + '-' + this.formatenumber(d) + ' ' + this.formatenumber(h) + ':' + this.formatenumber(mm) + ':' + this.formatenumber(s)
}
export default formate



// WEBPACK FOOTER //
// ./src/libs/util.time.js